/*
 * Trending now - drag the row sideways with the mouse.
 *
 * On a phone the row already swipes, because it is a scrolling strip. A mouse
 * cannot swipe, so on a computer this lets you press and drag it like the
 * product rows above. magnum-drag-guard.js stops the drag from opening the
 * pill it ends on.
 */
(function () {
  'use strict';

  function makeDraggable(row) {
    if (row.dataset.dragReady) return;
    row.dataset.dragReady = 'true';

    var startX = 0;
    var startScroll = 0;
    var pressed = false;

    row.addEventListener('pointerdown', function (event) {
      // Touch scrolls on its own; only take over for a mouse.
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (row.scrollWidth <= row.clientWidth) return; // Nothing to scroll.
      pressed = true;
      startX = event.clientX;
      startScroll = row.scrollLeft;
    });

    window.addEventListener('pointermove', function (event) {
      if (!pressed) return;
      var moved = event.clientX - startX;
      if (Math.abs(moved) > 3) row.classList.add('is-dragging');
      row.scrollLeft = startScroll - moved;
    });

    window.addEventListener('pointerup', function () {
      if (!pressed) return;
      pressed = false;
      row.classList.remove('is-dragging');
    });

    // Stop the browser picking up the link or photo as something to drag.
    row.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
  }

  function init() {
    document.querySelectorAll('.trending-now__list').forEach(makeDraggable);
  }

  init();
  // Runs again when the section is edited in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
